import { RootState } from '../../../store'

export const selectXlsxValidationErrors = (state: RootState) => state.xlsxValidation.errors

const selectors = {
  errors: selectXlsxValidationErrors,
}

export default selectors
